module.exports = __webpack_public_path__ + "static/img/4-open1.1df26005.png";